import type { ReactNode } from "react";
import { ChevronLeft, House } from "lucide-react";
import { useIntl } from "react-intl";
import { Button } from "./Button.js";
import styles from "./AppShell.module.css";

/** Wortmarke (Logo), kein übersetzbarer Text */
const BRAND_MARK = "aT";

export interface AppShellProps {
  appTitle: string;
  /** Rechts im Kopf: Kontext (Apotheke, Nutzer, Verbindung) */
  context?: ReactNode;
  /** In-App-Navigation – im Kiosk gibt es keinen Browser-Zurück-Button */
  onBack?: () => void;
  onHome?: () => void;
  banner?: ReactNode;
  children: ReactNode;
}

export function AppShell({ appTitle, context, onBack, onHome, banner, children }: AppShellProps) {
  const intl = useIntl();
  return (
    <div className={styles.shell}>
      <a className={styles.skip} href="#main">
        {intl.formatMessage({ id: "nav.skip" })}
      </a>
      <header className={styles.header}>
        <div className={styles.brand}>
          <span className={styles.mark} aria-hidden="true">
            {BRAND_MARK}
          </span>
          <span className={styles.brandText}>
            <span className={styles.brandName}>{intl.formatMessage({ id: "app.name" })}</span>
            <span className={styles.appTitle}>{appTitle}</span>
          </span>
        </div>
        {onBack || onHome ? (
          <nav className={styles.nav} aria-label={appTitle}>
            {onBack ? (
              <Button
                variant="quiet"
                className={styles.navButton}
                onPress={onBack}
                icon={<ChevronLeft className="omony-mirror" />}
              >
                {intl.formatMessage({ id: "nav.back" })}
              </Button>
            ) : null}
            {onHome ? (
              <Button variant="quiet" className={styles.navButton} onPress={onHome} icon={<House />}>
                {intl.formatMessage({ id: "nav.home" })}
              </Button>
            ) : null}
          </nav>
        ) : null}
        <div className={styles.context}>{context}</div>
      </header>
      {banner}
      <main id="main" tabIndex={-1} className={styles.main}>
        {children}
      </main>
    </div>
  );
}
